import React, { Component } from "react";
import { connect } from "react-redux";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import Flag from "semantic-ui-react/dist/es/elements/Flag";
import "./PostFooter.scss";
import CommentModal from "../CommentModal/CommentModal";
import ReplyModal from "../ReplyModal/ReplyModal";
import TempoTractionModal from "../TempoTractionModal/TempoTractionModal";
import ImageAnalyticsFooter from "../ImageAnalyticsModal/ImageAnalyticsFooter";
import EngagementModal from "../EngagementModal/EngagementModal";
import { ReactComponent as Star } from "../../../../assets/svg/grey-star.svg";
import { fetchPostReplys } from "../../../../actions/rawDataAction";
import { fetchPostComments, setSentiment } from "../../../../actions/dashboardAction";
import { ReactComponent as LikeIcon } from "../../../../assets/svg/like.svg";
import { ReactComponent as CommentIcon } from "../../../../assets/svg/comment.svg";
import { ReactComponent as ShareIcon } from "../../../../assets/svg/share.svg";
import { ReactComponent as YTLikeIcon } from "../../../../assets/svg/youtube-post-like.svg";
import { ReactComponent as YTDisLikeIcon } from "../../../../assets/svg/youtube-post-unlike.svg";
import { ReactComponent as TractionChart } from "../../../../assets/svg/traction.svg";
import { ReactComponent as Impact } from "../../../../assets/svg/impact.svg";
import { ReactComponent as Reach } from "../../../../assets/svg/noun-reach.svg";
import { ReactComponent as ImpactLow } from "../../../../assets/svg/impact-low.svg";
import { ReactComponent as Url } from "../../../../assets/svg/url.svg";
import { ReactComponent as EngagementRate } from "../../../../assets/svg/engagementrate.svg";
import { ReactComponent as ViralityIcon } from "../../../../assets/svg/viral-icon.svg";
import { ReactComponent as AssignedIcon } from "../../../../assets/svg/how_to_reg.svg";
import { ReactComponent as ClosedIcon } from "../../../../assets/svg/email-closed.svg";
import { ReactComponent as OpenedIcon } from "../../../../assets/svg/drafts.svg";
import { ReactComponent as ArchivedIcon } from "../../../../assets/svg/archive.svg";
import { ReactComponent as ProductAttributesIcon } from "../../../../assets/svg/Product_Atribute _search.svg";
import { ReactComponent as EngagmentChart } from "../../../../assets/svg/Engagment-icon.svg";
import { ReactComponent as ProductAttributeIcon } from "../../../../assets/svg/productAttributeIcon.svg";
import { ProductAttributes } from "../../../../components/MainContent/Dashboard/ProductAttributeValues";

import dislikeIcon from "./icons/dislike_icon.png";
import viewsIcon from "./icons/views_icon.png";
import InfoModal from "../VideoModal/VideoModal";
import PostPhraseModal from "./PostPhraseModal";

let socialIcons = {
    dislikeIcon,
    viewsIcon,
};

class PostFooter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comments: [],
            commentsPopupData: {},
            commentModalOpen: false,
            replysPopupData: {},
            replyModalOpen: false,
            tempoTractionData: null,
            tempoTractionModalOpen: false,
            phraseModal: false,
            engagementModalOpen: false,
            engagementData: null,
            productAttributesList: [],
        };
    }

    getSyncedStatusIcon = () => {
        let syncStatus = null;
        if (this.props.sync_status) {
            if (this.props.sync_status === "opened") syncStatus = <OpenedIcon />;
            if (this.props.sync_status === "closed") syncStatus = <ClosedIcon />;
            if (this.props.sync_status === "archived") syncStatus = <ArchivedIcon />;
            if (this.props.sync_status === "assigned") syncStatus = <AssignedIcon />;
        }
        return syncStatus;
    };

    showPostComments = (info) => {
        this.setState({
            commentsPopupData: info,
            commentModalOpen: true,
        });

        this.props.fetchPostComments(info.id, info.postTime[2], this.props.dashboardPageType === "research", info.postSubType).then((data) => {
            this.setState({ comments: data.value });
        });
    };

    showPostReplys = (info) => {
        this.setState({
            replysPopupData: info,
            replyModalOpen: true,
        });
        this.props.fetchPostReplys(info.id, info.postTime[2]);
    };

    tempoTractionModalShowSet = (show, data) => {
        if (data) data = JSON.parse(JSON.stringify(data));
        this.setState({
            tempoTractionModalOpen: show,
            tempoTractionData: data,
        });
    };

    EngagementModalShowSet = (show, data) => {
        if (data) {
            data = JSON.parse(JSON.stringify(data));
        }
        this.setState({
            engagementModalOpen: show,
            engagementData: data ? data : null,
        });
    };

    setPostSentiment = (sentiment) => {
        let args = {
            postData: this.props.postData,
            company: this.props.company,
            postIndex: this.props.postIndex,
            sentiment,
        };

        this.props.setSentiment(args).then((data) => {
            if (data.value) {
                this.props.updatePostAfterSentimentUpdate(data.value);

                this.setState({ commentsPopupData: { ...this.state.commentsPopupData, postSentiment: sentiment } });
            }
        });
    };

    setCommentSentiment = (sentiment, index) => {
        let args = {
            postData: this.state.comments[index],
            company: this.props.company,
            postIndex: this.props.postIndex,
            sentiment,
            isComment: true,
        };
        this.props.setSentiment(args).then((data) => {
            if (data.value) {
                let comments = [];
                this.state.comments.forEach((element) => {
                    comments.push(element);
                });
                comments[index].postSentiment = sentiment;
                this.setState({ comments });
            }
        });
    };

    showImageAnalyticsFooter = () => {
        if (
            Object.keys(this.props.data.imageAnalystics).length > 0 &&
            (Object.keys(this.props.data.imageAnalystics.Logos).length > 0 ||
                Object.keys(this.props.data.imageAnalystics.Objects).length > 0 ||
                Object.keys(this.props.data.imageAnalystics["Text in Images"]).length > 0 ||
                Object.keys(this.props.data.imageAnalystics.Scenes).length > 0)
        ) {
            return true;
        } else return false;
    };

    getRestNames = (members) => {
        return (
            <div className="rest-members">
                <div className="product-attr">Product Attributes :</div>
                {members.map((member, index) => {
                    return (
                        <div className="sort-options" key={member.user_id}>
                            <p>{member.attributeName}</p>
                        </div>
                    );
                })}
            </div>
        );
    };
    isValidURL = (url = "") => {
        const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?.*$/;
        return urlRegex.test(url);
    };

    render() {
        let ProductAttributesPostData = this.props?.data?.productAttributesForConversation || [];
        let ProductAttributesPostDataValues;
        if (ProductAttributesPostData?.length > 0) {
            ProductAttributesPostDataValues = ProductAttributes.data.filter((ele) => {
                return ProductAttributesPostData.some((v) => v.category == ele.categoryName);
            });
        }
        const isValidUrl = this.isValidURL(this.props.data?.postLink || "");
        return (
            <>
                <div className={`post-footer skiptranslate ${this.props.listView ? "post-footer-listview" : ""}`}>
                    <div className="post-footer-left">
                        {this.props.data.countries.length > 0 ? (
                            <div className="country-flags post-footer-item">
                                {this.props.data.countries.map((country) => (
                                    <Popup
                                        key={country[1]}
                                        trigger={<Flag name={country[1].toLowerCase()} />}
                                        content={country[0]}
                                        className="skiptranslate"
                                        size="mini"
                                        position="left center"
                                        inverted
                                    />
                                ))}
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.domainName !== "" ? (
                            <div className="domain-name post-footer-item">
                                <a href={this.props.data.postLink} target="_blank" rel="noreferrer">
                                    {" "}
                                    {this.props.data.domainName}{" "}
                                </a>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.platformName === "LexisNexis" ? (
                            <div className="domain-name lexisNexis post-footer-item">
                                <a href={this.props.data.originalSource} target="_blank" rel="noreferrer noopener">
                                    {this.props.data.originalSource}
                                </a>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.likesCount ? (
                            <div className="likes post-footer-item" title={this.props.data.socialIcons.totalLike.name}>
                                {this.props.data.platformName.toLowerCase() !== "youtube" ? <LikeIcon /> : <YTLikeIcon />}
                                <span className="count">{this.props.data.likesCount}</span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.dislikesCount ? (
                            <div className="dislikes post-footer-item" title={this.props.data.socialIcons.totalDislike.name}>
                                {this.props.data.platformName.toLowerCase() !== "youtube" ? (
                                    <img src={socialIcons[this.props.data.socialIcons.totalDislike.img]} alt="dislikes" />
                                ) : (
                                    <YTDisLikeIcon />
                                )}
                                <span className="count">{this.props.data.dislikesCount}</span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.commentsCount ? (
                            <div
                                className="comments post-footer-item"
                                title={this.props.data.socialIcons.comment.name}
                                onClick={() => {
                                    if (this.props.isPublic) return;
                                    this.showPostComments({
                                        ...this.props.data,
                                        _id: this.props.postData._index + ":" + this.props.postData._id,
                                        id: this.props.postData._source.post.id,
                                    });
                                }}>
                                {this.props.data.platformName.toLowerCase() !== "youtube" && <CommentIcon />}
                                <span className="count">
                                    {this.props.data.commentsCount}
                                    {this.props.data.platformName.toLowerCase() === "youtube" && " Comments"}
                                </span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.viewsCount ? (
                            <div className="views post-footer-item" title="VIEWS">
                                {this.props.data.platformName.toLowerCase() !== "youtube" && (
                                    <img src={socialIcons[this.props.data.socialIcons.totalViews.img]} alt="VIEWS" />
                                )}
                                <span className="count">
                                    {this.props.data.viewsCount}
                                    {this.props.data.platformName.toLowerCase() === "youtube" && " Views"}
                                </span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.replyCount ? (
                            <div
                                className="comments"
                                title="REPLIES"
                                onClick={() => {
                                    if (this.props.isPublic) return;
                                    this.showPostReplys({
                                        ...this.props.data,
                                        id: this.props.postData._source.post.id,
                                    });
                                }}>
                                {/* <CommentIcon />
                                <span className="count">{this.props.data.replyCount}</span>
                                <div className="separator"></div> */}
                            </div>
                        ) : null}
                        {this.props.data.rate !== null && this.props.data.rate !== 0 && this.props.data.platformName === "Facebook" ? (
                            <div
                                className="engagementRate post-footer-item"
                                title="Engagement Rate - Calculated based on the number of people who engaged with your Facebook posts
                        in comparison to your total follower audience.">
                                <EngagementRate />
                                <span className="count">{this.props.data.rate + "%"}</span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                        {this.props.data.sharesCount && this.props.data.platformName.toLowerCase() !== "youtube" ? (
                            <div className="shares post-footer-item" title={this.props.data.socialIcons.share.name}>
                                <ShareIcon />
                                <span className="count">{this.props.data.sharesCount}</span>
                                <div className="separator"></div>
                            </div>
                        ) : null}
                    </div>
                    {!this.props.engagement ? (
                        <div className="post-footer-right">
                            <div className="post-link post-footer-item">
                                {this.props?.data?.productAttributesForConversation?.length > 0 && this.props.company?.company_lite_company_id == 10202 && (
                                    <Popup
                                        trigger={<ProductAttributeIcon className="product-attr" />}
                                        content={() => this.getRestNames(ProductAttributesPostDataValues)}
                                        className=" product-attribute skiptranslate"
                                        size="mini"
                                        position="right center"
                                        inverted
                                    />
                                )}
                                {this.props.data.productAttributes.length > 0 && (
                                    <Popup
                                        trigger={<ProductAttributesIcon onClick={this.props.showPhraseModal} className="product-attr" />}
                                        content=" Product Attribute Phrase"
                                        className=" product-attribute skiptranslate"
                                        size="mini"
                                        position="left center"
                                        inverted
                                    />
                                )}

                                {!(
                                    (
                                        (this.props.postData._source.platforms[0].id === "27530fd3-fa3e-11e5-83d2-0656fc34e8c9" &&
                                            this.props.postData._source.source_type[0] === "2") ||
                                        (this.props.postData._source.platforms[0].id === "8de7e53a-ad28-11e4-b8cb-22000aa425f3" &&
                                            this.props.postData._source.source_type[0] === "2")
                                    )
                                    //  || !this.isValidURL(this.props.data.postLink)
                                ) &&
                                    isValidUrl && (
                                        <>
                                            <Popup
                                                trigger={
                                                    <a target="_blank" href={this.props.data.postLink} rel="noreferrer">
                                                        <Url className="post_viewMore" />
                                                    </a>
                                                }
                                                content="View More"
                                                className="skiptranslate"
                                                size="mini"
                                                position="left center"
                                                inverted
                                            />
                                        </>
                                    )}
                                {this.props.postData._source.platforms[0].id === "8de7e53a-ad28-11e4-b8cb-22000aa425f3" &&
                                    this.props.postData._source.source_type[0] === "2" && (
                                        <Popup
                                            trigger={
                                                <a onClick={() => this.props.LNOfflineModalShow()}>
                                                    <Url />
                                                </a>
                                            }
                                            content="View More"
                                            className="skiptranslate"
                                            size="mini"
                                            position="left center"
                                            inverted
                                        />
                                    )}
                                <div className="separator"></div>
                            </div>

                            {!this.props.data.EngagementData.nodata && (
                                <div className="engagement post-footer-item" title="View Engagement over Time Chart">
                                    <EngagmentChart
                                        title="View Engagement over Time Chart"
                                        onClick={() => this.EngagementModalShowSet(true, this.props.data.EngagementData.chartData)}
                                    />
                                    <div className="separator"></div>
                                </div>
                            )}
                            {this.props.data.tempoTractionData && (
                                <div className="traction post-footer-item" title="View Impact and Traction Graph">
                                    <TractionChart
                                        title="VIEW IMPACT AND TRACTION GRAPH"
                                        onClick={() => this.tempoTractionModalShowSet(true, this.props.data.tempoTractionData)}
                                    />
                                    <div className="separator"></div>
                                </div>
                            )}
                            {this.props.data &&
                                (this.props.data.platformName === "X" ||
                                    this.props.data.platformName === "Facebook" ||
                                    this.props.data.platformName === "Instagram" ||
                                    this.props.data.platformName === "TikTok") &&
                                this.props.data.estimatedReach !== "" && (
                                    <div className="impact post-footer-item" title="Estimated Reach">
                                        <Popup
                                            size="mini"
                                            position="right center"
                                            className="skiptranslate"
                                            content={"Reach: " + this.props.data.estimatedReach.estimatedReach}
                                            inverted
                                            trigger={
                                                <span>
                                                    <Reach className="big" />
                                                    {this.props.data.estimatedReach.formattedEstimatedReach !== 0 && (
                                                        <span className="count">{this.props.data.estimatedReach.formattedEstimatedReach}</span>
                                                    )}
                                                </span>
                                            }
                                        />
                                        <div className="separator"></div>
                                    </div>
                                )}

                            {this.props.data.tempoTraction && this.props.data.tempoTraction.tempoTractionValues !== "" && (
                                <div className="impact post-footer-item" title="Impact Value">
                                    <Popup
                                        size="mini"
                                        position="right center"
                                        className="skiptranslate"
                                        content={this.props.data.tempoTraction.tempoTractionValues}
                                        inverted
                                        trigger={
                                            <span>
                                                {this.props.data.tempoFlag === "flag-red" ? <Impact /> : <ImpactLow />}
                                                {this.props.data.tempoTraction.impact !== "0" && (
                                                    <span className="count">{this.props.data.tempoTraction.impact}</span>
                                                )}
                                            </span>
                                        }
                                    />
                                    <div className="separator"></div>
                                </div>
                            )}
                            {this.props.viralityType && (
                                <div className="virality post-footer-item">
                                    <Popup
                                        size="mini"
                                        position="left center"
                                        className="skiptranslate"
                                        content={this.props.data.viralityScore}
                                        inverted
                                        trigger={<ViralityIcon className={this.props.viralityType} />}
                                    />
                                    <div className="separator"></div>
                                </div>
                            )}
                            {this.props.sync_status && (
                                <div className="syncStatus post-footer-item">
                                    <Popup
                                        inverted
                                        size="mini"
                                        position="left center"
                                        className="skiptranslate"
                                        content={
                                            this.props.sync_status === "opened"
                                                ? "OPEN"
                                                : this.props.sync_status === "assigned"
                                                ? "SHARED"
                                                : this.props.sync_status.toUpperCase()
                                        }
                                        trigger={this.getSyncedStatusIcon()}
                                    />
                                    <div className="separator"></div>
                                </div>
                            )}

                            {this.props.data?.ratingCount > 0 && (
                                <div className="rating post-footer-item">
                                    <div className="post-gmb-ratings">
                                        {[...Array(this.props.data?.ratingCount)].map((star, i) => {
                                            return <Star key={i} />;
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : null}

                    <CommentModal
                        open={this.state.commentModalOpen}
                        hideModal={() => this.setState({ commentModalOpen: false, commentsPopupData: {}, comments: [] })}
                        dashboardPageType={this.props.dashboardPageType}
                        postInfo={this.state.commentsPopupData}
                        comments={this.state.comments}
                        commentsLoading={this.props.commentsFetching}
                        commentsRejected={this.props.commentsRejected}
                        downloadParentPostCsv={() =>
                            this.props.downloadParentPostCsv({ parent_id: this.props.postData._source.post.id, published_date: this.props.data.postTime[2] })
                        }
                        setPostSentiment={this.setPostSentiment}
                        setCommentSentiment={this.setCommentSentiment}
                    />
                    <ReplyModal
                        open={this.state.replyModalOpen}
                        hideModal={() => this.setState({ replyModalOpen: false, replysPopupData: {} })}
                        postInfo={this.state.replysPopupData}
                        replys={this.props.replys}
                        replysLoading={this.props.replysFetching}
                        replysRejected={this.props.replysRejected}
                    />
                    <TempoTractionModal
                        open={this.state.tempoTractionModalOpen}
                        hideModal={() => this.tempoTractionModalShowSet(false)}
                        data={this.state.tempoTractionData}
                    />

                    {/* <PostPhraseModal
                        open={this.state.phraseModal}
                        hideModal={() => this.setState({ phraseModal: false })}
                        // pharse={this.props.data.productAttributes[0].phrase}
                        data={this.props.data}
                    /> */}
                </div>

                {this.showImageAnalyticsFooter() && <ImageAnalyticsFooter data={this.props.data} />}
                <EngagementModal
                    open={this.state.engagementModalOpen}
                    hideModal={() => this.EngagementModalShowSet(false)}
                    data={this.state.engagementData}
                    postData={this.props.postData}
                    modalPostCardData={this.props.data}
                    downloadParentPostCsv={() =>
                        this.props.downloadParentPostCsv({ parent_id: this.props.postData._source.post.id, published_date: this.props.data.postTime[2] })
                    }
                    setPostSentiment={() => this.setPostSentiment()}
                    setCommentSentiment={this.setCommentSentiment}
                    company={this.props.company}
                    postIndex={this.props.postIndex}
                    updatePostAfterSentimentUpdate={this.props.updatePostAfterSentimentUpdate}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    // comments: state.dashboardReducer.postComments,
    commentsFetching: state.dashboardReducer.postCommentsFetching,
    commentsRejected: state.dashboardReducer.postCommentsRejected,
    replys: state.rawDataReducer.postReplys,
    replysFetching: state.rawDataReducer.postReplysFetching,
    replysRejected: state.rawDataReducer.postReplysRejected,
    company: state.globalReducer.company,
});

const mapDispatchToProps = (dispatch) => ({
    fetchPostComments: (parentId, published_date, isResearchPage, postSubType) =>
        dispatch(fetchPostComments(parentId, published_date, isResearchPage, postSubType)),
    fetchPostReplys: (parentId) => dispatch(fetchPostReplys(parentId)),
    setSentiment: (args) => dispatch(setSentiment(args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PostFooter);
